/* ============================================================
   LiquorVerse starlight headliner (Cosmos, migration phase 3.3).
   Injects a twinkling starfield into every [data-lv-sky] element,
   density weighted to the top where the sky is deepest, plus one
   slow shooting star per sky. Pairs with the .lv-sky CSS in
   lv-base.css. Fully defensive: no sky elements -> no-op.
   Honours prefers-reduced-motion (static, dimmer field).
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(sky) {
    if (sky.dataset.lvSkyDone) return;      // idempotent (Shopify section reloads)
    sky.dataset.lvSkyDone = '1';

    var STARS = 60;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < STARS; i++) {
      var s = document.createElement('i');
      var top = Math.pow(Math.random(), 1.7) * 80;                 // top-weighted
      var big = Math.random() > 0.82;
      var sz = big ? (Math.random() * 0.8 + 2.0) : (Math.random() * 0.7 + 1.0);
      s.style.cssText =
        'left:' + (Math.random() * 100).toFixed(1) + '%;' +
        'top:' + top.toFixed(1) + '%;' +
        'width:' + sz.toFixed(1) + 'px;height:' + sz.toFixed(1) + 'px;' +
        '--o1:' + (Math.random() * 0.28 + 0.12).toFixed(2) + ';' +
        '--o2:' + (Math.random() * 0.4 + 0.6).toFixed(2) + ';' +
        '--d:' + (Math.random() * 5 + 3).toFixed(1) + 's;' +
        '--dl:' + (Math.random() * 6).toFixed(1) + 's;';
      if (big) s.style.boxShadow = '0 0 4px 1px rgba(255,255,255,.5)';
      frag.appendChild(s);
    }
    sky.appendChild(frag);

    if (!reduce) {
      var shoot = document.createElement('div');
      shoot.className = 'lv-shoot';
      shoot.style.left = (Math.random() * 40 + 6) + '%';
      shoot.style.animationDelay = (2.5 + Math.random() * 6).toFixed(1) + 's';
      sky.appendChild(shoot);
    }
  }

  function run() {
    var skies = document.querySelectorAll('[data-lv-sky]');
    for (var i = 0; i < skies.length; i++) build(skies[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
